/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, input, InputSignal, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { StampMapMarkersComponent } from './components/markers/markers.component';
import { MAP_CONFIG } from './config/constants';

@Component({
  selector: "app-map-stamp",
  imports: [
    CommonModule,
    TranslateModule,
    GoogleMapsModule,
    StampMapMarkersComponent
  ],  
  standalone: true,
  templateUrl: "./map-stamp.component.html",
  styleUrls: ["./map-stamp.component.scss"],
  encapsulation: ViewEncapsulation.None
})

export class MapStampComponent {
    public markers: InputSignal<any> = input.required<any>();
    private mapPadding: any = { top: 150, right: 20, bottom: 100, left: 20 };
    public map: GoogleMap;
    public options: google.maps.MapOptions = MAP_CONFIG;
    public mapClickEvent = signal<google.maps.MapMouseEvent | null>(null);
    
    onMapReady(map) {
        this.map = map;
        this.centerMapByMarkers();
    }

    onMapClick(event: google.maps.MapMouseEvent) {
        this.mapClickEvent.set(event);
    }

    centerMapByMarkers(){
        const bounds = new google.maps.LatLngBounds();
        this.markers()?.forEach(marker => bounds.extend(new google.maps.LatLng(marker.location)));
        this.map.fitBounds(bounds, this.mapPadding);
    }

}
